import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';

class ArrayToStringPipe {
    /**
     * Converts an array of numbers or strings, into a string
     * @param values
     * @param delimiter
     */
    transform(values, delimiter = ' ') {
        if (values === null) {
            return null;
        }
        return values.filter((value) => value !== null).join(delimiter);
    }
}
ArrayToStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ArrayToStringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ArrayToStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: ArrayToStringPipe, isStandalone: true, name: "arrayToString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ArrayToStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'arrayToString',
                    standalone: true,
                }]
        }] });

class TruthyOrNullPipe {
    transform(...values) {
        return values.map((value) => value !== 'false' && Boolean(value)).includes(true) || null;
    }
}
TruthyOrNullPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TruthyOrNullPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TruthyOrNullPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: TruthyOrNullPipe, isStandalone: true, name: "truthyOrNull" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TruthyOrNullPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'truthyOrNull',
                    standalone: true,
                }]
        }] });

/**
 * Exposes the @angular/cdk coerceBooleanProperty function
 * as a pipe
 */
class CoerceBooleanPropertyPipe {
    transform(...values) {
        return values.map((value) => coerceBooleanProperty(value)).includes(true);
    }
}
CoerceBooleanPropertyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoerceBooleanPropertyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CoerceBooleanPropertyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: CoerceBooleanPropertyPipe, isStandalone: true, name: "coerceBooleanProperty" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoerceBooleanPropertyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'coerceBooleanProperty',
                    standalone: true,
                }]
        }] });

/**
 * Exposes the @angular/cdk coerceNumberProperty function
 * as a pipe
 */
class CoerceNumberPropertyPipe {
    transform(value) {
        return coerceNumberProperty(value);
    }
}
CoerceNumberPropertyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoerceNumberPropertyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CoerceNumberPropertyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: CoerceNumberPropertyPipe, isStandalone: true, name: "coerceNumberProperty" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoerceNumberPropertyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'coerceNumberProperty',
                    standalone: true,
                }]
        }] });

/**
 * Coerces negative values to null
 */
class ValueOrNullPipe {
    transform(value) {
        return value ? value : null;
    }
}
ValueOrNullPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ValueOrNullPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ValueOrNullPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: ValueOrNullPipe, isStandalone: true, name: "valueOrNull" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ValueOrNullPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'valueOrNull',
                    standalone: true,
                }]
        }] });

class CoersionModule {
}
CoersionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoersionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CoersionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: CoersionModule, imports: [TruthyOrNullPipe,
        ArrayToStringPipe,
        CoerceBooleanPropertyPipe,
        CoerceNumberPropertyPipe,
        ValueOrNullPipe], exports: [TruthyOrNullPipe,
        ArrayToStringPipe,
        CoerceBooleanPropertyPipe,
        CoerceNumberPropertyPipe,
        ValueOrNullPipe] });
CoersionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoersionModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: CoersionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TruthyOrNullPipe,
                        ArrayToStringPipe,
                        CoerceBooleanPropertyPipe,
                        CoerceNumberPropertyPipe,
                        ValueOrNullPipe
                    ],
                    exports: [
                        TruthyOrNullPipe,
                        ArrayToStringPipe,
                        CoerceBooleanPropertyPipe,
                        CoerceNumberPropertyPipe,
                        ValueOrNullPipe
                    ]
                }]
        }] });

/* istanbul ignore file */

/**
 * Generated bundle index. Do not edit.
 */

export { ArrayToStringPipe, CoerceBooleanPropertyPipe, CoerceNumberPropertyPipe, CoersionModule, TruthyOrNullPipe, ValueOrNullPipe };
